import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../services/api';

export function SubmitRequest({ userId, userUpn }: { userId: string; userUpn: string }) {
  const [text, setText] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [result, setResult] = useState<any>(null);
  const navigate = useNavigate();

  const handleSubmit = async () => {
    if (!text.trim()) return;
    setSubmitting(true);
    setResult(null);
    try {
      const res = await api.submitRequest(text, userId, userUpn);
      setResult(res);
      if (res.action === 'created') {
        setTimeout(() => navigate('/'), 2000);
      }
    } catch (e: any) {
      setResult({ action: 'error', message: e.message });
    }
    setSubmitting(false);
  };

  const handleVoteInstead = async (requestId: string) => {
    try {
      await api.vote(requestId, userId);
      setResult({ action: 'voted', message: 'Vote enregistre ! Redirection...' });
      setTimeout(() => navigate('/'), 1500);
    } catch (e: any) {
      alert(e.message);
    }
  };

  return (
    <div>
      <h2>Soumettre une demande d'evolution</h2>
      <p style={{ color: '#666', fontSize: 14 }}>
        Decrivez votre besoin en langage naturel. L'IA reformulera votre demande et verifiera si une demande similaire existe deja.
      </p>

      <textarea
        value={text}
        onChange={e => setText(e.target.value)}
        placeholder="Ex: J'aimerais pouvoir deployer des applications Win32 directement depuis Teams sans passer par le portail Intune..."
        disabled={submitting}
        style={{
          width: '100%', minHeight: 150, padding: 16, fontSize: 14, borderRadius: 8,
          border: '2px solid #ddd', fontFamily: 'inherit', resize: 'vertical',
          boxSizing: 'border-box',
        }}
      />

      <button onClick={handleSubmit} disabled={submitting || !text.trim()}
        style={{
          marginTop: 12, padding: '10px 32px', borderRadius: 4, border: 'none',
          background: submitting ? '#999' : '#0078d4', color: '#fff', fontSize: 15,
          cursor: submitting ? 'wait' : 'pointer',
        }}>
        {submitting ? 'Analyse en cours...' : 'Soumettre'}
      </button>

      {result && (
        <div style={{ marginTop: 20 }}>
          {result.action === 'created' && (
            <div style={{ background: '#e6f4ea', padding: 16, borderRadius: 8 }}>
              <h3 style={{ color: '#1e7e34', margin: '0 0 8px' }}>Demande creee !</h3>
              <p><strong>{result.title}</strong></p>
              <p style={{ color: '#555' }}>{result.description}</p>
              <p style={{ fontSize: 12, color: '#999' }}>Categorie : {result.category}</p>
            </div>
          )}

          {result.action === 'duplicate_found' && (
            <div style={{ background: '#fff8e1', padding: 16, borderRadius: 8 }}>
              <h3 style={{ color: '#f57f17', margin: '0 0 8px' }}>Demandes similaires trouvees</h3>
              <p style={{ fontSize: 14 }}>Votre demande reformulee : <strong>{result.rewritten?.title}</strong></p>
              <p style={{ fontSize: 13, color: '#555' }}>{result.rewritten?.description}</p>

              <div style={{ marginTop: 12 }}>
                <p style={{ fontSize: 14, fontWeight: 'bold' }}>Voulez-vous voter pour une demande existante ?</p>
                {(result.duplicates || []).map((d: any) => (
                  <div key={d.id} style={{ background: '#fff', padding: 12, borderRadius: 8, marginTop: 8, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>
                      <strong>{d.title}</strong>
                      <span style={{ marginLeft: 8, fontSize: 12, color: '#999' }}>{d.votes} votes | {d.status}</span>
                    </div>
                    <button onClick={() => handleVoteInstead(d.id)}
                      style={{ padding: '4px 16px', borderRadius: 4, border: 'none', background: '#0078d4', color: '#fff', cursor: 'pointer', fontSize: 13 }}>
                      Voter
                    </button>
                  </div>
                ))}
                <button onClick={handleSubmit}
                  style={{ marginTop: 12, padding: '6px 16px', borderRadius: 4, border: '1px solid #ddd', background: '#fff', cursor: 'pointer', fontSize: 13 }}>
                  Creer quand meme une nouvelle demande
                </button>
              </div>
            </div>
          )}

          {result.action === 'voted' && (
            <div style={{ background: '#e6f4ea', padding: 16, borderRadius: 8 }}>
              <p style={{ color: '#1e7e34' }}>{result.message}</p>
            </div>
          )}

          {result.action === 'error' && (
            <div style={{ background: '#fce8e6', padding: 16, borderRadius: 8 }}>
              <p style={{ color: '#c62828' }}>Erreur : {result.message}</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
